import React from 'react'
import CustomTextarea from '../../../components/Forms/CustomInputs/CustomTextarea';
import CustomImageUpload from '../../../components/Forms/CustomInputs/CustomImageUpload';
import CustomDropdown from '../../../components/Forms/CustomInputs/CustomDropdown';
import CustomTextbox from '../../../components/Forms/CustomInputs/CustomTextbox';
import { useSelector } from 'react-redux';

const EditProjectUI = ({
    formik,
    selectedRelationData,
    setSelectedRelationData
}) => {

    const { values, errors, handleChange, handleBlur, setFieldValue, touched } = formik;
    const { data: artForms } = useSelector((state) => state.category);
    const { data: genres } = useSelector((state) => state.genre);

    // Custom handler for Concept Title to limit to 50 characters
    const handleConceptTitleChange = (e) => {
        const value = e.target.value;
        // Limit to 50 characters
        if (value.length <= 50) {
            handleChange(e);
        }
    };

    // Handle paste event to limit to 50 characters
    const handleConceptTitlePaste = (e) => {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        const limitedValue = paste.substring(0, 50);
        if (limitedValue) {
            setFieldValue('conceptTitle', limitedValue);
        }
    };
    return (
        <>
            <div className="row">
                <CustomDropdown
                    fieldName="artForm"
                    values={selectedRelationData?.artForm}
                    error={touched.artForm ? errors.artForm : null}
                    label={"Art Form"}
                    classes={"col-md-6"}
                    setFieldValue={setFieldValue}
                    handleChange={(value) => {
                        setSelectedRelationData({ ...selectedRelationData, artForm: value, genre: {} })
                    }}
                    options={
                        artForms
                            ? artForms?.map((data) => {
                                return { label: data.name, value: data._id };
                            })
                            : []
                    }
                />

                <CustomDropdown
                    fieldName="genre"
                    values={selectedRelationData?.genre}
                    error={touched.genre ? errors.genre : null}
                    label={"Genre"}
                    classes={"col-md-6"}
                    setFieldValue={setFieldValue}
                    handleChange={(value) =>
                        setSelectedRelationData({ ...selectedRelationData, genre: value })
                    }
                    options={
                        genres
                            ? genres?.map((data) => {
                                return { label: data.name, value: data._id };
                            })
                            : []
                    }
                />

                <CustomTextbox
                    fieldName="conceptTitle"
                    value={values.conceptTitle}
                    error={touched.conceptTitle ? errors.conceptTitle : null}
                    label={"Concept Title"}
                    classes={"col-md-6"}
                    handleBlur={handleBlur}
                    inputType={"text"}
                    handleChange={handleConceptTitleChange}
                    inputProps={{
                        onPaste: handleConceptTitlePaste,
                        maxLength: 50
                    }}
                />

                <CustomDropdown
                    fieldName="duration"
                    values={selectedRelationData?.duration}
                    error={touched.duration ? errors.duration : null}
                    label={"duration"}
                    classes={"col-md-6"}
                    setFieldValue={setFieldValue}
                    handleChange={(value) =>
                        setSelectedRelationData({ ...selectedRelationData, duration: value })
                    }
                    options={
                        [{ label: 'Half Length - 30 Mins', value: 'Half Length - 30 Mins' }, { label: "Full Length - 55 Mins", value: "Full Length - 55 Mins" }]
                    }
                />

                <CustomDropdown
                    fieldName="previouslyShowcased"
                    values={selectedRelationData?.previouslyShowcased}
                    error={touched.previouslyShowcased ? errors.previouslyShowcased : null}
                    label={"Have you done shows previously for this concept?"}
                    classes={"col-md-12"}
                    setFieldValue={setFieldValue}
                    handleChange={(value) =>
                        setSelectedRelationData({ ...selectedRelationData, previouslyShowcased: value })
                    }
                    options={
                        [{ label: 'Yes', value: true }, { label: "No", value: false }]
                    }
                />

                <CustomImageUpload
                    fieldName="supportingMaterialPdf"
                    value={values.supportingMaterialPdf}
                    error={errors.supportingMaterialPdf}
                    label={"Material for your concept (PDF ONLY)"}
                    classes={"col-md-12"}
                    handleBlur={handleBlur}
                    inputType={"text"}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    mediaType="pdf"
                />

                <CustomTextarea
                    errors={touched.conceptNote ? errors : { conceptNote: false }}
                    setFieldValue={setFieldValue}
                    handleBlur={handleBlur}
                    values={values}
                    title={"Note"}
                    fieldName='conceptNote'
                />

            </div>
        </>
    );
}

export default EditProjectUI